<template>
	<div id="noerr">
		<div class="noerrMain">
			<div class="nothing nMain" v-if="boxState=='3'">
				<img src="../../assets/icons/nothing.png" />
				<p>暂无符合条件的数据</p>
				<Button type="primary" ghost style="margin-right: 20px;" to="/">返回首页</Button>
				<Button type="primary" ghost v-if="nothingNum!='1'" @click="refSearch">重新搜索</Button>
			</div>
			<div class="error nMain" v-else>
				<img src="../../assets/icons/error.png" />
				<p>服务器出现异常，请稍后重试</p>
				<Button type="primary" ghost style="margin-right: 20px;" to="/">返回首页</Button>
				<Button type="primary" ghost @click="refSearch">重新搜索</Button>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		props: ['nothingNum', 'boxState'],
		methods: {
			refSearch() {
				this.$emit('refSearch')
			}
		}
	}
</script>

<style>
	.noerrMain {
		width: 200px;
		margin: 50px auto;
	}

	.nMain {
		text-align: center;
	}

	.nMain img {
		width: 200px;
	}

	.nMain p {
		line-height: 40px;
		color: #ACACAC;
	}
</style>
